import { ToDo } from "../../Components/ToDo";
import { Step } from "../Step/Step";
import { Cash } from "../Step/Cash";
import { StepEvent, StepEventType } from "../Step/StepEvent";
import { StepType } from "../Step/StepType";
import { PaymentReturnInfoForCustomer } from "./Components/PaymentReturnInfoForCustomer";
import { PaymentReturnInfoForAdmin } from "./Components/PaymentReturnInfoForAdmin";
import { PaymentStepData } from "./Models/PaymentStepData";
import { PaymentStepState } from "./Models/PaymentStepState";
import { PaymentFormNames } from "../../Models/Payment/PaymentForm";
import { Line, MultilineInput } from "@tblabs/truffle";
import { DateTimeProvider } from "../../Services/DateTimeProvider";
import { CashType } from "../Step/CashType";


export class PaymentReturnStep extends Step<PaymentStepState>
{
    public Type = StepType.PaymentReturn;
    public Icon = "💸";
    public TitleForCustomer = () => `Zwrot środków`;
    public Title = () => `Zwrot środków (${PaymentFormNames[this.Data.Form.value]})`;

    public InitialState = PaymentStepState.Awaiting;
    public WellDoneStates = [PaymentStepState.Paid];
    public FailedDoneStates = [PaymentStepState.Canceled, PaymentStepState.Omitted];

    public get AsEvents(): StepEvent[]
    {
        return [
            new StepEvent(StepEventType.PaymentReturn, this.Order.Id, "💰", "Zwrot środków", this.Data.Deadline.value, this.IsDone)
        ];
    }
    public get Mana(): Cash[]
    {
        const cash: Cash[] = [];

        if (this.Data.State.Is(PaymentStepState.Paid))
        {
            cash.push(new Cash(CashType.ReturnedDeposit, this, this.Data.Amount.value, `Zwrot środków (${this.Data.Category.value})`, new Date(+this.Data.WhenPaid.value || +this.Data.Deadline.value)))
        }

        return cash;
    }
    public get WhenPlanned(): Date
    {
        return this.Data.Deadline.value;
    }
    public get WhenDone(): Date
    {
        return this.Data.WhenPaid.value;
    }

    constructor(public Data: PaymentStepData)
    {
        super(Data);
    }

    public STATES = {
        [PaymentStepState.Awaiting]: {
            StateName: "Oczekuje na zwrot",
            Timeout: () => this.Data.Deadline,
            Customer: {
                Content: () => [
                    `Oczekuj zwrotu środków`,
                    new PaymentReturnInfoForCustomer(this.Data, this.Order.People.First()),
                    `Średni czas transferu to 1-2 dni robocze.\nW przypadku większego opóźnienia - skontaktuj się z nami`
                ],
            },
            Admin: {
                Content: () => [
                    `Do zwrotu:\n`,
                    new PaymentReturnInfoForAdmin(this.Data, this.Order.People.First()),
                    new ToDo(`Wykonaj zwrot.\nJeśli płatność jest w krypto: Upewnij się, że zostało dobrze przeliczone i że ExchangeRate jest ten sam, bo wartość do zwrotu wyliczamy z proporcji a nie z bieżącego kursu!`)
                ],
                Actions: {
                    "✅": () => { this.Data.WhenPaid.value = DateTimeProvider.Now; this.GoTo(PaymentStepState.Paid); },
                    "❌": () => this.GoTo(PaymentStepState.Canceled),
                },
            },
        },
        [PaymentStepState.Paid]: {
            StateName: "Zwrócone",
            Customer: {
                Content: () => [`✅ Zwrot wykonany`],
            },
            Admin: {
                Content: () => [
                    `✅ Zwrot wykonany`,
                    new PaymentReturnInfoForAdmin(this.Data, this.Order.People.First()),
                ],
            },
        },
        [PaymentStepState.Canceled]: {
            StateName: "Odwołane",
            Customer: {
                Content: () => [`❌ Anulowano zwrot`],
            },
            Admin: {
                Content: () => [
                    `❌ Przelew anulowany (${this.Data.AmountAsString})`,
                    new ToDo(
                        `Jeśli tylko pominięty klinij X`,
                        new MultilineInput(this.Data.CancellationReason).Placeholder("Powód pominięcia zwrotu. Widoczne również dla klienta!").Rows(3)
                    )],
                Actions: {
                    "❌": () => this.GoTo(PaymentStepState.Omitted),
                },
            },
        },
        [PaymentStepState.Omitted]: {
            StateName: "Pominięte",
            Customer: {
                Content: () => [`✖️ Zwrot został pominięty z powodu: ${this.Data.CancellationReason.value || "nie podano"}.`],
            },
            Admin: {
                Content: () => [
                    `✖️ Zwrot pominięty (${this.Data.AmountAsString})`,
                    new Line(),
                    this.Data.CancellationReason.value
                ],
            },
        },   
        [PaymentStepState.Error]: {
            StateName: "Błąd płatności",
            Customer: {
                Content: () => [
                    `Błąd podczas wykonywania operacji.`],
            },
            Admin: {
                Content: () => [
                    `Wystąpił błąd podczas wykonywania operacji. Sytuacja wymaga wyjaśnienia!`],
            },
        },
        [PaymentStepState.Returned]: {
            StateName: "Zwrócone",
            Customer: {
                Content: () => [
                    `Płatność została anulowana przez bank. Trwa wyjaśnianie sytuacji...`],
            },
            Admin: {
                Content: () => [
                    `Płatność została anulowana przez bank. Sytuacja wymaga wyjaśnienia!`,
                ],
            },
        },
    };
}
